/* Studiomoda – fotoslider in productkaarten.
   Alleen de eerste foto laadt direct; overige foto's laden bij doorbladeren, hover over een kleur of aanraken. */
(function () {
  // Collectiepagina's: ronde kleurknoppen laden (apart bestand sm-colorfilter.js in dezelfde map)
  var SM_CF_VERSION = '3';
  var me = document.currentScript;
  if (me && me.src && /\/collections\//.test(location.pathname) && !window.smColorFilterLoading) {
    window.smColorFilterLoading = true;
    var cf = document.createElement('script');
    cf.src = me.src.replace('sm-card-swiper.js', 'sm-colorfilter.js') + (me.src.indexOf('?') > -1 ? '&' : '?') + 'cf=' + SM_CF_VERSION;
    cf.defer = true;
    document.head.appendChild(cf);
  }

  if (window.smCardSwiperInit) return;
  window.smCardSwiperInit = true;

  function loadSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  function initCard(el) {
    if (el.swiper || typeof Swiper === 'undefined') return;

    var container = el.closest('.product-card__figure') || el;
    var swiper = new Swiper(el, {
      slidesPerView: 1,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
        dynamicBullets: false
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev')
      },
      on: {
        slideChange: function () {
          // Huidige en volgende foto laden, zodat doorbladeren soepel blijft
          loadSlide(this.slides[this.activeIndex]);
          loadSlide(this.slides[this.activeIndex + 1]);
          if (this.pagination && this.pagination.update) this.pagination.update();
        },
        touchEnd: function () {
          if (this.pagination && this.pagination.update) this.pagination.update();
        }
      }
    });
    el.swiper = swiper;

    // Bij eerste interactie met de kaart alvast de tweede foto laden
    var card = el.closest('.product-card');
    if (card) {
      var warm = function () { loadSlide(swiper.slides[1]); };
      card.addEventListener('pointerenter', warm, { once: true });
      card.addEventListener('touchstart', warm, { once: true, passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-card__swiper').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Kaarten die later worden toegevoegd (filters, 'meer laden') – max. 1x per frame controleren
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Hover over een kleur-swatch -> naar de bijbehorende foto
  document.addEventListener('mouseenter', function (e) {
    var swatch = e.target.closest ? e.target.closest('.color-swatch[data-slide-index], .media-swatch[data-slide-index]') : null;
    if (!swatch) return;
    var card = swatch.closest('.product-card');
    var swiperEl = card && card.querySelector('.product-card__swiper');
    var index = parseInt(swatch.getAttribute('data-slide-index'), 10);
    if (swiperEl && swiperEl.swiper && !isNaN(index)) {
      loadSlide(swiperEl.swiper.slides[index]);
      swiperEl.swiper.slideTo(index);
    }
  }, true);
})();